// extracted by mini-css-extract-plugin
module.exports = {"main":"seedance_main__YiVCc","footerWrap":"seedance_footerWrap__qS5A9"};